import { NodeProps } from "reactflow";
import { Box } from "@mui/material";

import HandlerWrapper from "../Handlers/HandlerWrapper";
import CreateSingleResponseBlockType from "./CreateSingleResponseBlockType";
import EditLegendSvg from "../../svg/EditLegendSvg";
import DeleteLegendSvg from "../../svg/DeleteLegendSvg";
import NotOperatorLegendSvg from "../../svg/NotOperatorLegendSvg";
import { useReactFlowStateContextProvider } from "../../hooks/useReactFlowStateContextProvider";
import BlockNodeUI from "./BlockNodeUI";
import { GroupNodeType } from "../../../types/bert";
import useParameterAiConfigContext from "../../hooks/useParameterAiConfigContext";
import DialogButton from "@convin/components/custom_components/Button/DialogButton";
import { isDefined } from "@convin/utils/helper/common.helper";
import { Visibility } from "@mui/icons-material";
import { textColors } from "@convin/theme/palette";

const GroupBlockNode: React.FC<NodeProps<GroupNodeType>> = (props) => {
    const {
        dispatch,
        aiConfigState: { activeGroupBlock },
        currentVersion,
    } = useParameterAiConfigContext();
    const { deleteNode, setNodes } = useReactFlowStateContextProvider();
    const {
        id,
        data: {
            is_not,
            metadata: { name },
        },
    } = props;
    return (
        <HandlerWrapper AddComponent={CreateSingleResponseBlockType} {...props}>
            <BlockNodeUI
                {...{
                    name,
                    heading: "Group Block",
                    isGroupNode: true,
                    is_not,
                    is_active: activeGroupBlock?.blockId === id,
                }}
            >
                <Box className="flex items-center" gap={0.5}>
                    {!isDefined(currentVersion) ? (
                        <>
                            <button
                                onClick={() => {
                                    dispatch({
                                        type: "SET_ACTIVE_GROUP_BLOCK_ID",
                                        payload: {
                                            blockId: id,
                                        },
                                    });
                                }}
                            >
                                <EditLegendSvg />
                            </button>
                            <DialogButton
                                onDelete={() => {
                                    return new Promise(() => {
                                        deleteNode(id);
                                    });
                                }}
                                title="Delete Node"
                                message="Are you sure you want to delete this Node?"
                                DeleteOptionComponent={
                                    <button>
                                        <DeleteLegendSvg />
                                    </button>
                                }
                            />
                            <button
                                onClick={() => {
                                    setNodes((nodes) =>
                                        nodes.map((e) =>
                                            e.id === id
                                                ? {
                                                      ...e,
                                                      data: {
                                                          ...e.data,
                                                          is_not: !is_not,
                                                      },
                                                  }
                                                : e
                                        )
                                    );
                                }}
                            >
                                <NotOperatorLegendSvg />
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                onClick={() => {
                                    dispatch({
                                        type: "SET_ACTIVE_GROUP_BLOCK_ID",
                                        payload: {
                                            blockId: id,
                                        },
                                    });
                                }}
                                style={{
                                    width: 24,
                                    height: 24,
                                    backgroundColor: textColors["666"],
                                    borderRadius: "6px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Visibility
                                    sx={{
                                        width: 16,
                                        height: 16,
                                        color: "#fff",
                                    }}
                                />
                            </button>
                        </>
                    )}
                </Box>
            </BlockNodeUI>
        </HandlerWrapper>
    );
};

export default GroupBlockNode;
